module.exports = __webpack_public_path__ + "static/media/woman_circle_photo_guide.7487a98d.png";